import { render } from "./CarbonNeutral.vue?vue&type=template&id=f675f31e"
import script from "./CarbonNeutral.vue?vue&type=script&lang=js"
export * from "./CarbonNeutral.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__